import { atom, useAtom } from 'jotai';
import { atomsWithMutation } from 'jotai-tanstack-query';
import { IcsV1 } from '@icecreamsocial/api-resources';
import { publicKeyAtom } from '../publicKey';
import type { ICSVariables } from '../config';

export interface InfluencerCondensed {
	id: string;
	identifier: string;
	orderId: string;
	mobileNumber: string;
	name: string;
	email: string;
	inviteId: string;
	inviteLink: string;
	revenue: string;
	smsConsent: boolean;
	emailConsent: boolean;
}

export const influencerAtom = atom<Partial<InfluencerCondensed>>({});

export const [, createInfluencerAtom] = atomsWithMutation((get) => ({
	mutationKey: ['influencers'],
	mutationFn: async (
		body: Partial<InfluencerCondensed> & {
			campaignId: string;
			transactionId: string;
			influencerId: string;
			redirectVariables?: Partial<ICSVariables>
		}
	) => {
		const { data } = await IcsV1.CustomerV1.createInfluencer2(body, {
			publicKey: get(publicKeyAtom),
		});
		return data?.influencer;
	},
}));

// /**
//  * kind of weird but this is here for 2 reasons:
//  *  1) The API currently requires orderId even if there is no purchase being made.  this value cannout be null/undefined
//  *  2) We now show the order id on the widget if it is passed via the parent window
//  *
//  * because of this, the order confirmation will show up with our fake order id after the influencer is made.  We need to
//  * We will set the orderId to a valid string ("none").  If it is "none", we won't show the order on the UI, else we show the orderId
//  */
export const displayOrderIdAtom = atom<string | undefined>((get) => {
	const { data: influencer } = get(createInfluencerAtom);
	const { orderId } = influencer || {};

	return orderId?.toLowerCase() === 'none' || orderId === null
		? undefined
		: orderId;
});
